import Box from "@mui/material/Box";
import {FilmIcon} from "../LibrettoEditor/FilmIcon";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import ClosedCaptionOffOutlinedIcon from "@mui/icons-material/ClosedCaptionOffOutlined";
import React from "react";
import {CategoryOutlined, TuneOutlined} from "@mui/icons-material";

export const SidebarItems = {
    PROJECT: 'project',
    AI_TOOLS: 'ai_tools',
    PROPERTIES: 'properties',
    ELEMENTS: 'elements',
    CAPTIONS: 'captions',
    STOCK: 'stock',
}

const V2EditorSidebar = ({setSidebarItemSelected, sidebarItemSelected}) => {

    const mediaBarItemStyle = (isItemSelected) => {

        return {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: "12px",
            paddingX: '8px',
            alignItems: 'center',
            gap: '2px',
            alignSelf: 'stretch',
            background: isItemSelected ? "var(--app-bg-subtle)" : "transparent",
            borderRadius: '8px',
            border: isItemSelected ? '1px solid var(--app-border-muted)' : '1px solid transparent',
            transition: 'background-color 0.12s ease, border-color 0.12s ease',
            "&:hover": {
                background: "var(--app-bg-subtle)",
                borderColor: 'var(--app-border-subtle)',
                cursor: 'pointer',
            }
        }

    }

    const mediaBarItemTextStyle = (isItemSelected) => ({
        color: isItemSelected ? "var(--app-text-primary)" : "var(--app-text-muted)",
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '11px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '16px',
        letterSpacing: '0.32px',
        userSelect: 'none',
    })

    const handleClick = (item) => {
        if (sidebarItemSelected === item) {
            setSidebarItemSelected(null);
            return;
        }
        setSidebarItemSelected(item);
    }

    return <>
        <Box data-tour="sidebar-project-button" sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.PROJECT)} onClick={() => {
            handleClick(SidebarItems.PROJECT)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.PROJECT ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <FilmIcon/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.PROJECT)}>
                Project
            </Box>
        </Box>
        <Box data-tour="sidebar-ai-tools-button" sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.AI_TOOLS)} onClick={() => {
            handleClick(SidebarItems.AI_TOOLS)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.AI_TOOLS ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <AutoFixHighOutlinedIcon sx={{ fontSize: 21 }}/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.AI_TOOLS)}>
                AI Tools
            </Box>
        </Box>
        <Box data-tour="sidebar-properties-button" sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.PROPERTIES)} onClick={() => {
            handleClick(SidebarItems.PROPERTIES)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.PROPERTIES ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <TuneOutlined sx={{ fontSize: 21 }}/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.PROPERTIES)}>
                Properties
            </Box>
        </Box>
        <Box sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.ELEMENTS)} onClick={() => {
            handleClick(SidebarItems.ELEMENTS)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.ELEMENTS ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <CategoryOutlined sx={{ fontSize: 21 }}/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.ELEMENTS)}>
                Elements
            </Box>
        </Box>
        <Box sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.CAPTIONS)} onClick={() => {
            handleClick(SidebarItems.CAPTIONS)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.CAPTIONS ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <ClosedCaptionOffOutlinedIcon sx={{ fontSize: 21 }}/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.CAPTIONS)}>
                Captions
            </Box>
        </Box>
        {/*<Box sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.STOCK)} onClick={() => {*/}
        {/*    handleClick(SidebarItems.STOCK)*/}
        {/*}}>*/}
        {/*    <Box sx={{width: '24px', height: '24px'}}>*/}
        {/*        <CameraIcon/>*/}
        {/*    </Box>*/}
        {/*    <Box sx={mediaBarItemTextStyle}>*/}
        {/*        Stock*/}
        {/*    </Box>*/}
        {/*</Box>*/}
    </>
}

export default V2EditorSidebar;
